import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  createTransport,
  getTransport,
  updateTransport,
} from '../../api/homepageManagementTrafficInfo.api';
import Button from '../../components/Button';
import ErrorResponse from '../../components/ErrorResponse';
import SimpleHeader from '../../components/layout/SimpleHeader';
import Loader from '../../components/Loader';
import SelectCampus from '../../components/SelectCampus';
import useAuth from '../../hooks/useAuth';
import useAxios from '../../hooks/useAxios';
import useNotification from '../../hooks/useNotification';
import { IGetTransport } from '../../models/homepageManagementTrafficInfo.model';
import { RootState } from '../../store/rootReducer';

const Transport = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetTransport>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();

  const [isCreate, setIsCreate] = useState(true);
  const [subwayUse, setSubwayUse] = useState('');
  const [busUse, setBusUse] = useState('');

  useEffect(() => {
    if (currentCampus) {
      execute(getTransport(currentCampus));
    }
  }, [currentCampus]);

  useEffect(() => {
    if (res && !isLoading) {
      if (res.data) {
        setSubwayUse(res.data.subwayUse);
        setBusUse(res.data.busUse);
        setIsCreate(false);
      } else {
        setIsCreate(true);
      }
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
    }
  }, [submitRes, submitIsLoading]);

  const onSubmit = () => {
    isCreate
      ? submitExecute(
          createTransport({ campusCode: currentCampus, subwayUse, busUse }),
        )
      : submitExecute(updateTransport(currentCampus, { subwayUse, busUse }));
  };

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.transport.title1')}
      />

      <div className="comm-table__area rowType edit">
        <table>
          <tbody>
            <tr>
              <th className="text-center">{t('common.menu.campus')}</th>
              <td>
                <SelectCampus className='w-150p' />
              </td>
            </tr>
            <tr>
              <th className="text-center" rowSpan={4}>
                {t('homepage.transport.column1')}
              </th>
              <td>{t('homepage.transport.column2')}</td>
            </tr>
            <tr>
              <td>
                <textarea
                  rows={3}
                  value={subwayUse || ''}
                  onChange={e => setSubwayUse(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td>{t('homepage.transport.column3')}</td>
            </tr>
            <tr>
              <td>
                <textarea
                  rows={3}
                  value={busUse || ''}
                  onChange={e => setBusUse(e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div className="comm-bx__space">
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink"
              onClick={onSubmit}
              text={t('common.button.save')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transport;
